//#region src/kiosk_table_tracker_status.ts
let KioskTableTrackerStatus = /* @__PURE__ */ function(KioskTableTrackerStatus) {
	KioskTableTrackerStatus["Disconnected"] = "disconnected";
	KioskTableTrackerStatus["Connected"] = "connected";
	KioskTableTrackerStatus["Pending"] = "pending";
	KioskTableTrackerStatus["Empty"] = "empty";
	KioskTableTrackerStatus["Failed"] = "failed";
	return KioskTableTrackerStatus;
}({});
//#endregion
export { KioskTableTrackerStatus };

//# sourceMappingURL=kiosk_table_tracker_status.js.map